import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class MilestoneService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async getMilestones(projectUUID) {

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async createMilestones(projectUUID, title) {

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID) + "&title=" + encodeURIComponent(title);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone/Create" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getMilestoneDetailed(milestoneUUID) {

        const queryString = "?milestoneUUID=" + encodeURIComponent(milestoneUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone/Detail" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    // api/Milestone/Tasks
    async getTasksInMilestone(milestoneUUID) {

        const queryString = "?milestoneUUID=" + encodeURIComponent(milestoneUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async addTasksToMilestone(milestoneUUID, taskUUIDs) {
        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?milestoneUUID=" + encodeURIComponent(milestoneUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async removeTasksFromMilestone(milestoneUUID, taskUUIDs) {
        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?milestoneUUID=" + encodeURIComponent(milestoneUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Milestone/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "DELETE",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

}


// WEBPACK FOOTER //
// ./src/service/MilestoneService.js